module.exports = __webpack_public_path__ + "img/5.112f1f00.jpg";